module.exports = "<div>\n    <lazy-component @show=\"showLocation\">\n    </lazy-component>\n</div>"